export default __webpack_public_path__ + "static/media/image5.62c0cd17.png";